// removed by extract-text-webpack-plugin
module.exports = {"CheckoutSummary":"CheckoutSummary__CheckoutSummary__33vkE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/order/CheckoutSummary/CheckoutSummary.css
// module id = 139
// module chunks = 0